import axios from 'axios';
import authProvider from './authProvider/authProvider'; // Adjust path if needed

//https://api-tests.morango4.bitcliq.com
const API_BASE_URL = 'https://api-tests.morango4.bitcliq.com';

const instance = axios.create({
  baseURL: API_BASE_URL
});

// Request: attach session token
instance.interceptors.request.use((config) => {
  const sessionGuid = localStorage.getItem('session-guid');
  if (sessionGuid) {
    config.headers['x-session-guid'] = sessionGuid;
  }
  return config;
});

// Response: handle session expiration
instance.interceptors.response.use(
  response => response,
  async error => {
    const resData = error?.response?.data;

    if (
      resData?.success === false &&
      resData?.message === 'Invalid or expired session'
    ) {
      // Trigger React Admin logout process
      await authProvider.logout();

      // Fallback redirect (in case logout doesn't auto-redirect)
      window.location.href = '/#/login';

      return Promise.reject(error);
    }

    return Promise.reject(error);
  }
);

export default instance;
